<template>
        <!-- 顶部导航条 -->
    <div ref="headerBox" class="header_box" :style="`color:${color}`">
        <div class="container flex justify-between items-center">
            <div class="flex items-center font13">
                <span>您好！欢迎来到铸造宝</span>
                <el-divider direction="vertical"/>
                <span v-if="isLogin" class="  cursor-pointer linkHover">
                    {{ userInfo.realName? userInfo.realName : userInfo.nickName }}
                    <el-dropdown trigger="click"  @command="select_userMenu">
                        <i class="el-icon-caret-bottom" :style="`color:${color}`"></i>
                        <el-dropdown-menu slot="dropdown">
                            <el-dropdown-item command="/my_profile">个人账户</el-dropdown-item>
                            <el-dropdown-item command="/enterprise_profile">企业档案</el-dropdown-item>
                            <el-dropdown-item command="/my_account">账户信息</el-dropdown-item>
                            <el-dropdown-item command="/">我的控制台</el-dropdown-item>
                        </el-dropdown-menu>
                    </el-dropdown>
                </span>
                <span v-else class="font13  cursor-pointer linkHover" @click="go_login()">登录</span>
                <el-divider direction="vertical"/>
                <span v-if="isLogin" class="font13  cursor-pointer linkHover" @click="go_logout">退出</span>
                <span v-else class="font13  cursor-pointer linkHover" @click="go_register()">注册</span>
            </div>
            <div class="flex items-center font13 ">
                <span class="cursor-pointer linkHover" @click="go_page('/index')">铸造宝首页</span>
                <el-divider direction="vertical"/>
                <span class="cursor-pointer linkHover" @click="go_client('/')">我的控制台</span>
                <el-divider direction="vertical"/>
                <!-- <span class="cursor-pointer linkHover" @click="go_page('/shopping_cart')">我的购物车</span>
                <el-divider direction="vertical"/>
                <span class="cursor-pointer linkHover" @click="go_page('/collection')">我的关注</span>
                <el-divider direction="vertical"/> -->
                <span class="cursor-pointer linkHover" @click="go_page('/benefits')">会员权益</span>
                <el-divider direction="vertical"/>
                <span class="cursor-pointer linkHover" @click="go_page('/help_center')">帮助中心</span>
                <el-divider direction="vertical"/>
                <span class="cursor-pointer linkHover" @click="go_page('/support')">客服中心</span>
                <el-divider direction="vertical"/>
                <el-dropdown @command="select_language">
                    <div class="flex items-center cursor-pointer">
                        <span  :style="`color:${color}`">中文</span>
                        <el-image :src="require('@/assets/bigImg/language-icon.png')" style="width:20px;height: 15px; margin: 0 5px;"></el-image>
                        <i class="el-icon-arrow-down"  :style="`color:${color}`"></i>
                    </div>
                    <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item command="zh">中文</el-dropdown-item>
                        <el-dropdown-item command="en">英文</el-dropdown-item>
                    </el-dropdown-menu>
                </el-dropdown>

            </div>
        </div>
    </div>
</template>

<script>
	export default {
        name:'',
        props:{
            color:{
                type:String,
                default:'#898686'
            }

        },
        data () {
            return {

            }
        },
        components: {},
        computed: {
            userInfo(){
                return this.$store.getters.userInfo
            },
            isLogin(){
                return this.$store.getters.isLogin
            },
        },
        beforeMount() {},
        mounted() {},
        methods: {
            select_language(command){
                if(command=='en'){
                    window.open(process.env.VUE_APP_MAIN_URL_EN, '_blank')
                }
            },
            select_userMenu(command){//登录后选择的菜单
                window.open(this.$redirectUrl.jumpClient() + command, '_blank')
            },
            go_page(path){//临时菜单 跳转路由
                this.$router.push({path:path})
            },
            go_client(path){//跳转企业控制台
                window.open(this.$redirectUrl.jumpClient() + path)
            },
            go_login(){//跳转登录
                // window.location.href = `${this.$redirectUrl.jumpPassport()}/login?clientId=zhuzaobao&redirectUri=${this.$redirectUrl.jumpHome()}/index`
                const routeObj = {
                    path:this.$route.path,
                    query:this.$route.query
                }
                window.location.href = this.$generateRedirect('/login', routeObj)
            },
            go_register(){//跳转注册
				        // window.location.href = `${this.$redirectUrl.jumpPassport()}/register?clientId=zhuzaobao&redirectUri=${this.$redirectUrl.jumpHome()}/index`
                const routeObj = {
                    path:this.$route.path,
                    query:this.$route.query
                }
                window.location.href = this.$generateRedirect('/register', routeObj)
            },
            go_logout(){//退出登录
                this.$confirm('确定要退出登录吗?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.$store.dispatch('user/logout')
                }).catch(() => {
                    this.$message({ type: 'info', message: '已取消操作' })
                })
            },

        },
    }

</script>

<style lang='scss' scoped>
.header_box{
    min-width: 1200px;
    border-bottom: 1px solid #D7DAE2;
    padding: 10px 0;
    height: 22px;
    line-height: 22px;

}
</style>
